import {Box, Stack, Typography} from "@mui/material";
import type {SxProps, Theme} from "@mui/material";
import React from "react";

function AxisBar(props: {min: number; max: number}) {
	const tickHeight = 8;
	const tickWidth = 2;
	const lineHeight = 2;

	const tick: SxProps<Theme> = {
		position: "absolute",
		top: (lineHeight - tickHeight) / 2,
		width: tickWidth,
		height: tickHeight,
		backgroundColor: (theme) => theme.palette.grey[500],
	};

	return (
		<Stack sx={{alignItems: "center", width: 1}}>
			<Stack
				direction="row"
				sx={{
					justifyContent: "space-between",
					width: `calc(100% + ${tickWidth * 2}px)`,
					mb: 0.5,
				}}
			>
				<Typography variant="caption">{props.min}</Typography>
				<Typography variant="caption">{props.max}</Typography>
			</Stack>

			<Stack direction="row" sx={{width: 1, position: "relative"}}>
				<Box
					sx={{
						position: "absolute",
						left: 0,
						right: 0,
						height: `${lineHeight}px`,
						backgroundColor: (theme) => theme.palette.grey[500],
					}}
				/>
				<Box sx={{...tick, left: 0}} />
				<Box sx={{...tick, right: 0}} />
			</Stack>
		</Stack>
	);
}

export default AxisBar;
